import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toiture_a1, toiture_a2, maison_a1, maison_a2, toit_presentation, iconLoupe, iconToit, iconEtanche, iconGouttiere } from '../images/imageImports';
import useScrollAnimation from '../hooks/useScrollAnimation';
import useSeo from '../hooks/useSeo';
import { iconToiture } from '../images/imageImports';
import './CouverturePage.css';

const CouverturePage = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [servicesRef, servicesVisible] = useScrollAnimation(0.1);
  useSeo({
    title: 'Couverture · Vie et couleurs (Couëron)',
    description: 'Expert en couverture à Couëron - Région nantaise : traitement anti-mousse, hydrofuge, reprise de faîtage, changement d\'ardoise. Artisan qualifié pour tous vos travaux de toiture en région nantaise. Devis gratuit.',
    canonical: 'https://www.vie-et-couleurs.fr/couverture'
  });

  const photos = [
    {
      id: 1,
      title: "Traitement toiture",
      description: "Nettoyage, traitement anti-mousse et protection hydrofuge des tuiles.",
      beforeSrc: toiture_a1,
      afterSrc: toiture_a2
    },
    {
      id: 2,
      title: "Traitement toiture",
      description: "Nettoyage, traitement anti-mousse et protection hydrofuge des ardoises.",
      beforeSrc: maison_a1,
      afterSrc: maison_a2
    }
  ];

  const openModal = (photo) => {
    setSelectedPhoto(photo);
  };

  const closeModal = () => {
    setSelectedPhoto(null);
  };

  // Empêcher le scroll de l'arrière-plan quand la modale est ouverte
  useEffect(() => {
    if (selectedPhoto) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Nettoyer l'effet au démontage du composant
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedPhoto]);
  return (
    <div className="couverture-page">
      {/* Header Section */}
      <section className="couverture-header">
        <div className="container">
          <div>
            <h1 className="page-title">Couverture</h1>
            <p className="page-subtitle">
              Découvrez notre savoir-faire en couverture et toiture, étanchéité et zinguerie pour protéger votre habitation
            </p>
          </div>
        </div>
      </section>

      {/* Galerie retirée */}

      {/* Couverture Section */}
      <section id="couverture" className="service-section">
        <div className="container">
          <div className={`service-content scroll-animate ${servicesVisible ? 'visible' : ''}`} ref={servicesRef}>
            <div className="service-text">
              <h2 className="service-title"><img src={iconToiture} alt="Couverture" className="title-icon" />Couverture</h2>
              <p className="service-description">
                Interventions de couverture ciblées pour protéger durablement votre toiture.
              </p>
              <div className="service-details">
                <h3>Prestations</h3>
                <ul>
                  <li>Traitement anti-mousse</li>
                  <li>Hydrofuge</li>
                  <li>Changement d'ardoise</li>
                  <li>Reprise de faîtage</li>
                </ul>
              </div>

              <div className="service-features">
                <div className="feature-item">
                  <span className="feature-icon">✅</span>
                  <span>Intervention rapide en cas d'urgence</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✅</span>
                  <span>Devis détaillé et transparent</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✅</span>
                  <span>Protection durable contre les intempéries</span>
                </div>
              </div>
            </div>
            
            <div className="service-image">
              <div className="image-card">
                <img src={toit_presentation} alt="Présentation couverture - Vie et couleurs" className="image-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Photos Avant/Après Section */}
      <section className="photos-section service-section-alt">
        <div className="container">
          <h2 className="section-title">Nos Réalisations - Avant/Après</h2>
          <p className="photos-subtitle">Découvrez la transformation de nos projets de couverture</p>
          
          <div className="photos-grid">
            {photos.map((photo) => (
              <div key={photo.id} className="photo-card" onClick={() => openModal(photo)}>
                <div className="photo-container">
                  <div className="photo-before">
                    <img src={photo.beforeSrc} alt={`${photo.title} - Avant`} />
                  </div>
                  <div className="photo-after">
                    <img src={photo.afterSrc} alt={`${photo.title} - Après`} />
                  </div>
                </div>
                <div className="photo-info">
                  <h3>{photo.title}</h3>
                  <p>{photo.description}</p>
                </div>
                <div className="photo-overlay">
                  <img src={iconLoupe} alt="Zoom" className="zoom-icon" style={{height:'20px', width:'20px'}} />
                  <p>Cliquez pour agrandir</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Types de Couverture Section */}
      <section className="types-couverture-section service-section-alt">
        <div className="container">
          <h2 className="section-title">Nos Types de Couverture</h2>
          <div className="couverture-grid">
            <div className="couverture-type-card">
              <div className="couverture-icon">
                <img src={iconToit} alt="Tuiles" style={{height:'48px', width:'48px'}} />
              </div>
              <h3>Tuiles</h3>
              <p>Tuiles terre cuite, béton, ardoise. Esthétique et durabilité pour votre toiture.</p>
              <ul className="couverture-features">
                <li>Résistance aux intempéries</li>
                <li>Esthétique traditionnelle</li>
                <li>Durabilité 30+ ans</li>
              </ul>
            </div>

            <div className="couverture-type-card">
              <div className="couverture-icon">
                <img src={iconEtanche} alt="Étanchéité" style={{height:'48px', width:'48px'}} />
              </div>
              <h3>Étanchéité</h3>
              <p>Étanchéité plate-forme, toitures terrasses. Protection contre les infiltrations.</p>
              <ul className="couverture-features">
                <li>Protection renforcée</li>
                <li>Matériaux modernes</li>
                <li>Durabilité éprouvée</li>
              </ul>
            </div>

            <div className="couverture-type-card">
              <div className="couverture-icon">
                <img src={iconGouttiere} alt="Zinguerie" style={{height:'48px', width:'48px'}} />
              </div>
              <h3>Zinguerie</h3>
              <p>Gouttières, descentes, évacuation. Gestion des eaux pluviales optimisée.</p>
              <ul className="couverture-features">
                <li>Évacuation efficace</li>
                <li>Matériaux durables</li>
                <li>Installation professionnelle</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Urgences Section */}
      <section className="urgences-section">
        <div className="container">
          <h2 className="section-title">Interventions d'Urgence</h2>
          <div className="urgences-content">
            <div className="urgence-info">
              <h3>🚨 Fuite ou Dégât des Eaux ?</h3>
              <p>Notre équipe intervient rapidement en cas d'urgence pour limiter les dégâts et protéger votre habitation.</p>
              <div className="urgence-features">
                <div className="urgence-feature">
                  <span className="feature-icon">⏰</span>
                  <span>Intervention sous 24h</span>
                </div>
                <div className="urgence-feature">
                  <span className="feature-icon">🛠️</span>
                  <span>Réparation temporaire immédiate</span>
                </div>
                <div className="urgence-feature">
                  <span className="feature-icon">📞</span>
                  <span>Disponible 7j/7</span>
                </div>
              </div>
              <a href="tel:0766059863" className="btn btn-urgence link-plain">
                Appeler en urgence
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="container">
          <h2 className="section-title">Notre Processus de Couverture</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Diagnostic</h3>
              <p>Inspection complète de la toiture et identification des problèmes et solutions.</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Devis Détaillé</h3>
              <p>Établissement d'un devis transparent avec choix des matériaux et planning.</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Préparation</h3>
              <p>Protection du chantier, dépose de l'ancienne couverture et préparation des supports.</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Réalisation</h3>
              <p>Pose de la nouvelle couverture avec techniques professionnelles et finitions soignées.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="devis" className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Besoin d'un devis pour vos travaux de couverture ?</h2>
            <p>Contactez-nous pour discuter de votre projet et obtenir une estimation gratuite.</p>
            <Link to="/contact" className="btn btn-primary btn-large">
              Demander un devis
            </Link>
          </div>
        </div>
      </section>

      {/* Modal pour afficher les photos en grand */}
      {selectedPhoto && (
        <div className="photo-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <div className="modal-photo-container">
              <div className="modal-photo-before">
                <img src={selectedPhoto.beforeSrc} alt={`${selectedPhoto.title} - Avant`} />
              </div>
              <div className="modal-photo-after">
                <img src={selectedPhoto.afterSrc} alt={`${selectedPhoto.title} - Après`} />
              </div>
            </div>
            <div className="modal-info">
              <h3>{selectedPhoto.title}</h3>
              <p>{selectedPhoto.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CouverturePage;
